import React from 'react'
import {KTSVG} from '../../../template/_metronic/helpers'

type InputProps = React.HTMLProps<HTMLInputElement>

const CustomDateInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <div className='position-relative d-flex align-items-center'>
      <KTSVG
        path='/media/soyfri-media/calendar.svg'
        className='svg-icon-1 position-absolute ms-5 text-primary pe-4 border-1 border-end border-gray-300'
      />
      <input
        className={`form-control form-control-solid bg-gray-100 ps-12 flatpickr-input active ps-20 text-primary-dark fs-2 ${props.className}`}
        onClick={props.onClick}
        ref={ref}
        placeholder={props.placeholder}
      />
    </div>
  )
})

export default CustomDateInput
